import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../../lt-style/lt-style.css";
import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import LeftMenu from "../LeftMenu/LeftMenu";
import Reach from "../../pages/Reach";
import Directory from "../../pages/Directory";
import Analytics from "../../pages/Analytics";
import UserAccess from "../../pages/intranet/Settings/UserAccess";
import styled from "styled-components";
import Home from "../../pages/Home";
import IntranetWebparts from "../../pages/intranet/Webparts";
import Navigation from "../../pages/intranet/navigation/Navigation";
import Megamenu from "../../pages/intranet/navigation/Megamenu";
import Matrix from "../../pages/intranet/navigation/Matrix";
import DocsTemplate from "../../pages/DocsTemplate";
import intranetWebpartsData from "../../data/intranetWebparts";
import vivaCardsData from "../../data/vivaCards";
import VivaCards from "../../pages/intranet/VivaCards";
import IntranetGovernance from "../../pages/intranet/Governance";
import IntranetMetadata from "../../pages/intranet/Metadata";
import IntranetWorkspaces from "../../pages/intranet/Workspaces";
import Breadcrumb from "../../components/Breadcrumb";
import Intranet from "../../pages/Intranet";
import Settings from "../../pages/intranet/Settings/Settings";
import { useAppContext } from "../../Context/AppContext";
import ThemeSummary from "../../pages/intranet/branding/ThemeSummary";
import ThemeName from "../../pages/intranet/branding/ThemeName";
import { BrandingProvider } from "../../pages/intranet/branding/BrandingContext";
import envVarConfig from "../../env/envVarConfig";
import UnderConstructionPage from "../../pages/UnderConstruction";
import Logo from "../../pages/intranet/branding/Logo";
import Color from "../../pages/intranet/branding/Color";
import EditTheme from "../../pages/intranet/branding/EditTheme";
import SiteCollection from "../../pages/intranet/branding/SiteCollection";
import BorderStyle from "../../pages/intranet/branding/BorderStyle";
import MenuTextOptions from "../../pages/intranet/branding/MenuTextOptions";
import SubmenuType from "../../pages/intranet/branding/SubmenuType";
import Policies from "../../pages/ixp/policies/Policies";
import { FluentProvider } from "@fluentui/react-components";
import FontManager from "../../pages/intranet/branding/FontManager";
import ReachAnalytics from "../../pages/ReachAnalytics";
import SharePointAnalytics from "../../pages/SharePointAnalytics";
import General from "../../pages/everywhere/general/general";
import LivetilesWebparts from "../../pages/intranet/branding/LivetilesWebparts";
import Audiences from "../../pages/ixp/audiences/Audiences";
import Quicklinks from "../../pages/ixp/quicklinks/Quicklinks";
import Assistant from "../../pages/everywhere/assistant/assistant";
import MyArea from "../../pages/everywhere/myarea/myarea";
const OuterContainer = styled.div.withConfig({ displayName: "OuterContainer", componentId: "-fv49if" }) `
  display: flex;
  background-color: #eee;
  padding: 2em;
  height: 100vh;
`;
const AppContainer = styled.div.withConfig({ displayName: "AppContainer", componentId: "-lzpfqa" }) `
  --color-primary: #512da8;
  display: flex;
  justify-content: space-between;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(20px);
  position: relative;
  width: 100%;
  overflow: hidden;

  .custom-switch {
    transform: scale(0.8);
  }
`;
// TODO: This is a temporary solution to avoid breaking the build
const MigrateFromIXP = envVarConfig.environment === "local" || envVarConfig.environment === "dev";
const PageContainer = styled.main.withConfig({ displayName: "PageContainer", componentId: "-f7mqjz" }) `
  width: ${(props) => (props.$isSubmenuVisible ? "75%" : "87.5%")};
  padding-left: 2rem;
  transition: all 0.35s ease-in-out;
  margin-right: 8px;
  margin-block: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.125);
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.25);
  }
`;
export const Layout = React.memo((props) => {
    const { appState, setAppState } = useAppContext();
    const [isSubmenuVisible, setIsSubmenuVisible] = useState(false);
    const userName = appState.name;
    const nonProdEnv = envVarConfig.environment === "local" ||
        envVarConfig.environment === "dev" ||
        envVarConfig.environment === "test";
    useEffect(() => {
        const userString = sessionStorage.getItem("User");
        if (!userString)
            return;
        const user = JSON.parse(userString);
        setAppState((prevState) => (Object.assign(Object.assign({}, prevState), { name: user.name })));
    }, []);
    const handleSubmenuVisibilityChange = (isSubmenuVisible) => {
        setIsSubmenuVisible(isSubmenuVisible);
    };
    const generateDocsRoutes = (data) => {
        return data.map((item, i) => {
            return (_jsx(Route, { path: `${item.route}`, element: _jsx(DocsTemplate, { title: item.title, downloadUrl: item.downloadUrl, docsPage: item.docsPage }) }, i));
        });
    };
    return (_jsx(FluentProvider, Object.assign({ theme: props.lightTheme }, { children: _jsx(OuterContainer, { children: _jsxs(AppContainer, Object.assign({ className: "lt-style" }, { children: [_jsx(LeftMenu, { onSubmenuVisibilityChange: handleSubmenuVisibilityChange }), _jsxs(PageContainer, Object.assign({ "$isSubmenuVisible": isSubmenuVisible, id: "page-root" }, { children: [_jsx(Breadcrumb, {}), _jsxs(Routes, { children: [_jsx(Route, { path: "", element: _jsx(Home, { userName: userName }) }), _jsx(Route, { path: "/under-construction", element: _jsx(UnderConstructionPage, {}) }), _jsx(Route, { path: "/intranet", element: _jsx(Intranet, {}) }), _jsx(Route, { path: "/intranet/navigation", element: _jsx(Navigation, {}) }), _jsx(Route, { path: "/intranet/webparts", element: _jsx(IntranetWebparts, {}) }), _jsxs(Route, Object.assign({ path: "/intranet/navigation/megamenu", element: _jsx(Megamenu, {}) }, { children: [_jsx(Route, { path: "/intranet/navigation/megamenu/:menuId/:configTab", element: _jsx(Megamenu, {}) }), _jsx(Route, { path: "/intranet/navigation/megamenu/:menuId/", element: _jsx(Megamenu, {}) })] })), _jsx(Route, { path: "/intranet/navigation/matrix", element: _jsx(Matrix, {}) }), _jsx(Route, { path: "/intranet/governance", element: _jsx(IntranetGovernance, {}) }), _jsx(Route, { path: "/intranet/metadata", element: _jsx(IntranetMetadata, {}) }), _jsx(Route, { path: "/intranet/webparts", element: _jsx(IntranetWebparts, {}) }), _jsx(Route, { path: "/intranet/viva", element: _jsx(VivaCards, {}) }), _jsx(Route, { path: "/intranet/workspaces", element: _jsx(IntranetWorkspaces, {}) }), _jsx(Route, { path: "/intranet/branding", element: _jsx(BrandingProvider, { children: _jsx(ThemeSummary, {}) }) }), _jsx(Route, { path: "/intranet/branding/name", element: _jsx(BrandingProvider, { children: _jsx(ThemeName, { wizardMode: true }) }) }), _jsx(Route, { path: "/intranet/branding/site-collections", element: _jsx(BrandingProvider, { children: _jsx(SiteCollection, { wizardMode: true }) }) }), _jsx(Route, { path: "/intranet/branding/color", element: _jsx(BrandingProvider, { children: _jsx(Color, { wizardMode: true }) }) }), _jsx(Route, { path: "/intranet/branding/logo", element: _jsx(BrandingProvider, { children: _jsx(Logo, { wizardMode: true }) }) }), _jsx(Route, { path: "/intranet/branding/border", element: _jsx(BrandingProvider, { children: _jsx(BorderStyle, { wizardMode: true }) }) }), _jsx(Route, { path: "/intranet/branding/text-options", element: _jsx(BrandingProvider, { children: _jsx(MenuTextOptions, { wizardMode: true }) }) }), _jsx(Route, { path: "/intranet/branding/submenu-type", element: _jsx(BrandingProvider, { children: _jsx(SubmenuType, { wizardMode: true }) }) }), _jsx(Route, { path: "/intranet/branding/font", element: _jsx(BrandingProvider, { children: _jsx(FontManager, { wizardMode: true }) }) }), _jsx(Route, { path: "/intranet/branding/livetiles-webparts-base", element: _jsx(BrandingProvider, { children: _jsx(LivetilesWebparts, { wizardMode: true, page: "base" }) }) }), _jsx(Route, { path: "/intranet/branding/livetiles-webparts-item", element: _jsx(BrandingProvider, { children: _jsx(LivetilesWebparts, { wizardMode: true, page: "item" }) }) }), _jsx(Route, { path: "/intranet/branding/edit", element: _jsx(BrandingProvider, { children: _jsx(EditTheme, {}) }) }), _jsx(Route, { path: "/intranet/quicklinks", element: _jsx(Quicklinks, {}) }), _jsx(Route, { path: "/intranet/audiences", element: _jsx(Audiences, {}) }), _jsx(Route, { path: "/intranet/policies", element: _jsx(Policies, {}) }), _jsx(Route, { path: "/reach", element: _jsx(Reach, {}) }), _jsx(Route, { path: "/directory", element: _jsx(Directory, {}) }), _jsx(Route, { path: "/analytics", element: _jsx(Analytics, {}) }), _jsx(Route, { path: "/analytics/sharepoint", element: _jsx(SharePointAnalytics, {}) }), _jsx(Route, { path: "/analytics/reach", element: _jsx(ReachAnalytics, {}) }), _jsx(Route, { path: "/settings", element: _jsx(Settings, {}) }), _jsx(Route, { path: "/settings/useraccess", element: _jsx(UserAccess, { isAdmin: appState.isAdmin }) }), _jsx(Route, { path: "/everywhere/general", element: _jsx(General, {}) }), _jsx(Route, { path: "/everywhere/assistant", element: _jsx(Assistant, {}) }), _jsx(Route, { path: "/everywhere/myarea", element: _jsx(MyArea, {}) }), generateDocsRoutes(intranetWebpartsData), generateDocsRoutes(vivaCardsData)] })] }))] })) }) })));
});
